import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { calcPercent } from './util';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import LargeProgressBar from './LargeProgressBar';
import Maybe from 'components/@common/Maybe';

type Props = {
  completedPercent: any;
  supportedPercent: any;
};
const colors = {
  primary: {
    met: '#51A486',
    notMet: '#EA031F'
  },
  secondary: {
    met: '#FFC20E',
    notMet: '#919191'
  }
};

const LargeBarChart: React.FC<Props> = ({ completedPercent, supportedPercent }) => {
  const classes = useStyles();

  return (
    <Box display="flex" flex={1} flexDirection="column">
      <LargeProgressBar
        currentPercent={Math.round(completedPercent)}
        metColor={colors.primary.met}
        notMetColor={colors.primary.notMet}
        metDescription={<Description text="Skills Met" />}
        MetEndAdornment={
          <CheckCircleIcon
            fontSize="small"
            color="inherit"
            classes={{ root: `${classes.icon} ${classes.check}` }}
          />
        }
        notMetDescription={<Description text="Skills Not Met" />}
        NotMetEndAdornment={
          <CancelIcon fontSize="small" color="error" classes={{ root: classes.icon }} />
        }
        title="Completed Lessons"
      />
      <Maybe shouldRender={completedPercent > 0}>
        <Box width={`${calcPercent(completedPercent, 100)}%`}>
          <LargeProgressBar
            title="Supports Provided"
            notMetDescription={
              <Description text="Did not need Support Path" style={{ marginLeft: 6 }} />
            }
            currentPercent={Math.round(supportedPercent)}
            metColor={colors.secondary.met}
            notMetColor={colors.secondary.notMet}
            metDescription={<Description text="Needed Support Path" />}
            MetEndAdornment={
              <FiberManualRecordIcon
                style={{
                  fontSize: 12,
                  alignSelf: 'center',
                  color: '#FFC20E'
                }}
              />
            }
          />
        </Box>
      </Maybe>
    </Box>
  );
};

const Description = ({ text, style }: { text: string; style?: React.CSSProperties }) => (
  <Typography variant="h6" style={{ fontWeight: 400, ...style }}>
    {text}
  </Typography>
);

const useStyles = makeStyles(() => ({
  icon: {
    fontSize: 12,
    alignSelf: 'center',
    marginLeft: 4
  },
  check: {
    color: '#51A486'
  }
}));

export default LargeBarChart;
